function getSelector(node) {
  if (!node) {
    return "NULL";
  } else {
    const idStr = node.id ? "#" + node.id : "";
    const className = node.className ? ('.' + (node.className.baseVal ?? node.className)) : '';
    const classStr = className.trim().replace(/ /g, ".");
    const prefix =
      node.parentElement && node.parentElement.tagName != "BODY"
        ? getSelector(node.parentElement) + " > "
        : "";
    return `${prefix}${(
      node.tagName ?? "n/a"
    ).toLowerCase()}${idStr}${classStr}`;
} 
}

function getRect(rect) {
  const res = {};
  const attrs = ["x", "y", "top", "bottom", "left", "right", "height", "width"];
  attrs.forEach((attr) => (res[attr] = rect[attr]));
  return res;
}

function getRectStr(rect) {
  return `(${rect.x},${rect.y}) [${rect.width}x${rect.height}]`;
}

function getSrcStr(src) {
  return `${getSelector(src.node)}\n  to ${getRectStr(
    src.currentRect
  )} from ${getRectStr(src.previousRect)}`;
}

function markPerformanceEntry(entry) {
     const roundedValue = Math.round(entry.value * 10000) / 10000;
     const markPrefix = `Layout shift ${roundedValue}`;
     const parentShiftDetails = {
       startTime: entry.startTime,
       value: entry.value,
     };
     if (entry.sources && entry.sources.length) {
       const numSources = entry.sources.length;
       entry.sources.forEach((src, i) => {
         const markName = `${markPrefix} ${i + 1}/${numSources}\n ${getSrcStr(
           src
         )}`;
         const performanceDetail = {
           parentShift: parentShiftDetails,
           nodeSelector: getSelector(src.node),
           currentRect: getRect(src.currentRect),
           previousRect: getRect(src.previousRect),
         };
         performance.mark(markName, {
           startTime: parentShiftDetails.startTime,
           detail: performanceDetail,
         });
       });
     }
}

export default function observePerformance() {
     new PerformanceObserver((entryList) => entryList.getEntries().forEach(markPerformanceEntry))
                                .observe({ type: "layout-shift", buffered: true });
}